module.exports = __webpack_public_path__ + "static/img/22.acc4853.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/22.jpg
// module id = yZSE
// module chunks = 16